import { combineReducers } from 'redux';
import reducerAuthenticationToken from './reducerAuthenticationToken';
import reducerBookingTypes from './reducerBookingTypes';
import reducerAppLoader from './reducerAppLoader';
import reducerShopCart from './reducerShopCart'
import reducerExtraItems from './reducerExtraItems';
import reducerMember from './reducerMember';
import reducerPaymentTransaction from './reducerPaymentTransaction'
import reducerIP from './reducerIP'
import reducerCalendarView from './reducerCalendarView'
import reducerCardDiscardTime from './reducerCardDiscardTime'
import reducerDisplayAreas from './reducerDisplayAreas';
import reducerCoupon from './reducerCoupon';
import reducerTourProduct from './reducerTourProduct';
import reducerGiftCardHold from './reducerGiftCardHold';
import reducerUniqueCouponHolds from './reducerUniqueCouponHolds';
import reducerMemberValidation from './reducerMemberValidation';
import reducerFormError from './reducerFormError';
import reducerDonation from './reducerDonation';
import reducerTransactionFee from './reducerTransactionFee';
import reducerMembershipPackages from './reducerMembershipPackages';
import reducerGaTicket from './reducerGaTicket';
import reducerLostMember from './reducerLostMember';
import reducerMemberMemberships from './reducerMemberMemberships';
import reducerCustomer from './reducerCustomer';
import reducerBooking from './reducerBooking';
import reducerGiftCardDisplayAreas from './reducerGiftCardDisplayAreas';
import reducerGiftCards from './reducerGiftCards';
import reducerCostRate from './reducerCostRate';
import reducerIDMeUserData from './reducerIDMeUserData';
import reducerBookingUserDefinedFields from './reducerBookingUserDefinedFields';
import reducerOrderLocations from './reducerOrderLocations';
import reducerOrderMenu from './reducerOrderMenu';
import reducerMembershipUserDefinedFields from './reducerMembershipUserDefinedFields';
import reducerCustomerUDFs from './reducerCustomerUDFs';
import reducerCountryAndState from './reducerCountryAndState';
import reducerOrganizationSection from './reducerOrganizationSection';
import reducerProduct from './reducerProduct';
import reducerRecaptcha from './reducerRecaptcha';
import reducerGlobal from './reducerGlobal';
import reducerCustomerAddresses from './reducerCustomerAddresses';
import reducerMenuAndPages from './reducerMenuAndPages';

const rootReducer = combineReducers({
    reducerAuthenticationToken, reducerBookingTypes, reducerAppLoader,
    reducerShopCart, reducerMember, reducerPaymentTransaction,
    reducerExtraItems, reducerIP, reducerCalendarView, reducerCardDiscardTime,
    reducerDisplayAreas, reducerGiftCardHold, reducerCoupon, reducerTourProduct,
    reducerUniqueCouponHolds, reducerMemberValidation, reducerFormError, reducerDonation,
    reducerTransactionFee, reducerMembershipPackages, reducerGaTicket, reducerLostMember, reducerMemberMemberships,
    reducerCustomer, reducerBooking, reducerGiftCardDisplayAreas, reducerGiftCards, reducerCostRate, reducerIDMeUserData,
    reducerBookingUserDefinedFields, reducerOrderLocations, reducerOrderMenu, reducerMembershipUserDefinedFields,
    reducerCustomerUDFs, reducerCountryAndState, reducerProduct, reducerOrganizationSection, reducerRecaptcha,
    reducerGlobal, reducerCustomerAddresses, reducerMenuAndPages
});

export default rootReducer;
